import { Certification } from '../types/index'
export const validateSingleCertification = (cert: Certification) => {
  const errors: any = {};

  if (!cert.name?.trim()) {
    errors.name = "Certification name is required";
  }

  if (!cert.issuing_organization?.trim()) {
    errors.issuing_organization = "Issuing organization is required";
  }

  // 🔥 FIXED EXPIRATION VALIDATION
  if (!cert.does_not_expire) {
    if (!cert.issue_date) {
      errors.issue_date = "Issued date is required";
    }

    if (!cert.expiration_date) {
      errors.expiration_date = "Expiration date is required";
    }

    if (cert.issue_date) {
      const issue = new Date(cert.issue_date);
      const today = new Date();

      // Remove time portion
      today.setHours(0, 0, 0, 0);

      if (issue > today) {
        errors.issue_date = "Issue date cannot be in the future";
      }
    }

    if (cert.expiration_date) {
      const expiry = new Date(cert.expiration_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (expiry < today) {
        errors.expiration_date = "Expiration date cannot be in the past";
      }
    }

    if (cert.issue_date && cert.expiration_date) {
      const issue = new Date(cert.issue_date);
      const expiry = new Date(cert.expiration_date);

      if (expiry < issue) {
        errors.expiration_date =
          "Expiration date cannot be before issue date";
      }
    }
  }

  return errors;
};